import { render, staticRenderFns } from "./alipay-edit.vue?vue&type=template&id=b5dbb6e0&"
import script from "./alipay-edit.vue?vue&type=script&lang=js&"
export * from "./alipay-edit.vue?vue&type=script&lang=js&"
import style0 from "./alipay-edit.vue?vue&type=style&index=0&id=b5dbb6e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports